export function homography(source, target) {
  const rows=[];
  source.forEach(([x,y],i)=>{
    const [u,v]=target[i];
    rows.push([x,y,1,0,0,0,-u*x,-u*y,u]);
    rows.push([0,0,0,x,y,1,-v*x,-v*y,v]);
  });
  for(let c=0;c<8;c++){
    let pivot=c;for(let r=c+1;r<8;r++)if(Math.abs(rows[r][c])>Math.abs(rows[pivot][c]))pivot=r;
    if(Math.abs(rows[pivot][c])<1e-10)throw Error('Choose four distinct wall corners in clockwise order.');
    [rows[c],rows[pivot]]=[rows[pivot],rows[c]];
    const scale=rows[c][c];for(let j=c;j<=8;j++)rows[c][j]/=scale;
    for(let r=0;r<8;r++)if(r!==c){const f=rows[r][c];for(let j=c;j<=8;j++)rows[r][j]-=f*rows[c][j];}
  }
  return [...rows.map(r=>r[8]),1];
}
export function project(h,x,y){const d=h[6]*x+h[7]*y+h[8];if(Math.abs(d)<1e-10)throw Error('Wall perspective is too extreme.');return [(h[0]*x+h[1]*y+h[2])/d,(h[3]*x+h[4]*y+h[5])/d];}
export function convex(points){
  let sign=0;
  for(let i=0;i<4;i++){const a=points[i],b=points[(i+1)%4],c=points[(i+2)%4];const cross=(b[0]-a[0])*(c[1]-b[1])-(b[1]-a[1])*(c[0]-b[0]);if(Math.abs(cross)<.001)return false;if(sign&&Math.sign(cross)!==sign)return false;sign=Math.sign(cross);}
  return true;
}
export function cssMatrix(h){return `matrix3d(${[h[0],h[3],0,h[6],h[1],h[4],0,h[7],0,0,1,0,h[2],h[5],0,h[8]].join(',')})`;}
export function artworkCorners(wall, wallWidth, wallHeight, artWidth, artHeight, center){
  if(!convex(wall))throw Error('Mark wall corners clockwise: top left, top right, bottom right, bottom left.');
  if(!(wallWidth>0&&wallHeight>0&&artWidth>0&&artHeight>0))throw Error('Enter the wall and painting dimensions to calibrate scale.');
  if(artWidth>wallWidth||artHeight>wallHeight)throw Error('This painting is larger than the selected wall area.');
  const h=homography([[0,0],[1,0],[1,1],[0,1]],wall);
  const rw=artWidth/wallWidth,rh=artHeight/wallHeight;
  const x=Math.max(rw/2,Math.min(1-rw/2,center[0])),y=Math.max(rh/2,Math.min(1-rh/2,center[1]));
  return [[x-rw/2,y-rh/2],[x+rw/2,y-rh/2],[x+rw/2,y+rh/2],[x-rw/2,y+rh/2]].map(([u,v])=>project(h,u,v));
}
